import { useContext } from 'react';
import { SettingsContext } from './context';

/** @deprecated */
export const useSettings = () => useContext(SettingsContext);
